'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCoffee = function IoCoffee(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.9 20.1c2.9 0.5 5.1 3.1 5.1 6.2 0 1.5-0.6 3-1.6 4.2-1.2 1.3-2.9 2-4.8 2-0.6 0-1.3-0.1-2-0.2-0.4-0.1-0.7-0.3-1.1-0.4-0.9 1.1-1.8 1.9-2.5 2.6-0.4 0.3-1 0.5-1.5 0.5h-8c-0.5 0-1.1-0.2-1.5-0.5-1.3-1.2-3.2-2.9-4.8-6.8s-2.2-7.1-2.2-8.6 0.2-1.6 1.3-1.6h7.8c-0.3-1.3-2.8-1.5-2.8-3.6 0-1.3 1.1-2.5 2.1-2.9-0.1 0.6-0.2 1.1-0.2 1.7 0 1.4 3.1 2.3 3.1 4.1 0 0.2 0 0.5-0.1 0.7h4.3c0.1-0.4 0.2-0.8 0.2-1.1 0-2.8-4.4-2.8-4.4-6.6 0-2.1 1.7-4.3 3.7-4.8-0.3 1.1-0.7 1.8-0.7 2.7 0 2.5 4.5 3.9 4.5 6.9 0 1-0.4 2-1 2.9h6c1 0 1.2 0 1.2 1.6 0 0.3 0 0.6-0.1 1z m-1.3 9.9c2.6 0 3.9-2 3.9-3.7s-1.3-3.4-3-3.7c-0.4 1.5-0.9 3.3-1.7 5.1-0.3 0.7-0.6 1.4-0.9 2 0.4 0.2 1 0.3 1.7 0.3z' })
        )
    );
};

exports.default = IoCoffee;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/coffee.js
// module id = 2482
// module chunks = 168707334958949